import React from 'react';
import PropTypes from 'prop-types';

export const TimelineInstapointsInfo = ({
  timeline_meta: { heading, sub_heading } = {},
  index,
  timelineLength,
  configFor,
  timerVal
}) => {
  return (
    <div
      className={`timeline-meta-data ${configFor} ${index === 0 ? 'first' : ''} ${
        index === timelineLength - 1 ? 'last' : ''
      }`}
    >
      {heading && heading.text && (
        <div className={`timeline-heading-wrapper ${configFor}`}>
          <p className={`${heading.className ? heading.className : ''}`}>{heading.text}</p>
        </div>
      )}
      {sub_heading && sub_heading.text && (
        <div className={`timeline-sub-heading-wrapper ${configFor}`}>
          <p className={`${sub_heading.className ? sub_heading.className : ''} `}>
            {sub_heading.text}
          </p>
        </div>
      )}
      {sub_heading && sub_heading.show_timer && (
        <p className={`${sub_heading.className ? sub_heading.className : ''} `}>{timerVal}</p>
      )}
    </div>
  );
};

TimelineInstapointsInfo.propTypes = {
  timeline_meta: PropTypes.any,
  index: PropTypes.any,
  timelineLength: PropTypes.any,
  configFor: PropTypes.any,
  timerVal: PropTypes.any
};
